module.exports = {"title":"Registrieren","registerButton":"Registrieren","password":"Passwort","alreadyRegistered":"Bereits registriert?","loginAction":"Anmelden","meta":"Registrieren"}


//////////////////
// WEBPACK FOOTER
// ./src/assets/i18n/lang/de/signup.json
// module id = N283
// module chunks = 1